/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/22/21
 */

import {gql} from "urql";

export const SamlLoginMutation = gql`
    mutation SamlLogin {
        samlLogin {
            ok
            id
            firstName
            lastName
            fullName
            businessUnit
	        location
	        jobTitle
            sessionExpires
        }
    }
`;

export interface SamlLoginResponse {
	samlLogin: SamlLoginResult
}

export interface SamlLoginResult {
	ok: boolean
	id?: string
	firstName?: string
	lastName?: string
	fullName?: string
	location?: string
	jobTitle?: string
	businessUnit: string
	sessionExpires: string
}